import { ErrorStatus } from "components/ErrorStatus/ErrorStatus"
import { Modal } from "components/Modal/Modal"
import { Visit } from "interface/visit"
import { ComponentProps } from "react"
import { useUpdateVisit } from "services/visits"

interface CancelVisitProps extends ComponentProps<typeof Modal> {
	visit: Partial<Visit>
	onSuccess: VoidFunction
	errorMessage?: string
}

export function CancelVisit({
	visit: { id, ...partialVisit },
	open,
	title = "Do you want to cancel this visit request?",
	okText = "Yes, cancel it",
	cancelText = "No, keep it",
	children,
	errorMessage = "A unexpected error occurred while canceling the visit.",
	onSuccess,
	...props
}: CancelVisitProps) {
	const { mutateAsync: cancel, isPending, isError } = useUpdateVisit(id!)
	const handleCancelVisit = async () => {
		await cancel(partialVisit)

		onSuccess()
	}

	if (!open) {
		return null
	}

	return (
		<Modal
			{...props}
			open={open}
			title={title}
			okText={okText}
			cancelText={cancelText}
			okButtonProps={{ danger: true }}
			confirmLoading={isPending}
			onOk={handleCancelVisit}
			classNames={{ body: "flex flex-col gap-2" }}
		>
			{children}
			<ErrorStatus show={isError}>
				{`${errorMessage} Please, try again.`}
				<br />
			</ErrorStatus>
		</Modal>
	)
}
